import { Flex } from '@/components';
import type { FC, PropsWithChildren } from 'react';

export const CommentDetailsFooterWrapper: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <Flex
      style={{
        position: 'sticky',
        bottom: -24,
        left: 0,
        paddingBottom: 24,
        backgroundColor: '#fff',
      }}
      vertical
      gap={16}
    >
      {children}
    </Flex>
  );
};
